





import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import SupportedLocale from '@/types/SupportedLocale';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { LocalizationGetter } from '@/store/getters';

@Component({
  name: 'app',
  components: {
    'default-layout': DefaultLayout,
  },
})
export default class App extends Vue {
  @Prop({ default: 'default-layout' })
  private activeLayout: string | undefined;

  get locale(): SupportedLocale {
    return this.$store.getters[LocalizationGetter.Locale];
  }

  get layout() {
    return this.activeLayout;
  }

  public mounted() {
    this.$i18n.locale = this.locale.toString();
  }

  @Watch('locale')
  public onLocaleChange(locale: SupportedLocale) {
    this.$i18n.locale = locale;
  }
}
